import { FontAwesomeIconStyle } from '@fortawesome/react-native-fontawesome';
import { ViewStyle } from 'react-native';
import { color, dimensions, palette, spacing } from '../../theme';

/**
 * All CalendarListItems will start off looking like this.
 */
const BASE_VIEW: ViewStyle = {
  paddingHorizontal: dimensions.calendarListItemSeparation * 2,
  paddingVertical: spacing[2],
  borderRadius: dimensions.buttonRadius,
  marginVertical: dimensions.calendarListItemSeparation,
};

export const MAIN_VIEW: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center',
};

export const CONTENT_VIEW: ViewStyle = {
  marginLeft: 12,
  marginTop: spacing[4],
};

export const ITEM_VIEW: ViewStyle = {
  flexDirection: 'row',
  paddingBottom: 16,
};

export const ITEM_CANCEL_BUTTON: ViewStyle = {
  borderRadius: dimensions.buttonRadius / 2,
  padding: spacing[3],
};

export const TITLE_VIEW: ViewStyle = {
  flex: 1,
  marginHorizontal: spacing[3],
};

export const ICON_VIEW: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'flex-start',
};

export const FAMILY_MEMBERS_ICONS: ViewStyle = {
  flexDirection: 'row',
  marginLeft: 25,
};

export const EDIT_ICON: FontAwesomeIconStyle = {
  color: palette.dim,
};

export const ADD_TEXT_AREA: FontAwesomeIconStyle = {
  marginBottom: spacing[3],
  marginTop: spacing[3],
  marginLeft: spacing[2],
  marginRight: spacing[2],
};

export const LIST_EDIT_BUTTON_VIEW: FontAwesomeIconStyle = {
  marginTop: spacing[3],
  marginLeft: spacing[2],
};

/**
 * All the variations of text styling within the app.
 *
 * You want to customize these to whatever you need in your app.
 */
export const viewPresets = {
  Alarm: { ...BASE_VIEW, backgroundColor: `${color.alarm}1A` } as ViewStyle,
  Alert: { ...BASE_VIEW, backgroundColor: `${color.alert}1A` } as ViewStyle,
  Event: { ...BASE_VIEW, backgroundColor: `${color.event}1A` } as ViewStyle,
  Goal: { ...BASE_VIEW, backgroundColor: `${color.goal}1A` } as ViewStyle,
  Meal: { ...BASE_VIEW, backgroundColor: `${color.meal}1A` } as ViewStyle,
};
